import React from "react";
import styled from "styled-components";

const HorizontalDivider = ({ className, style, destructive }) => {
  const props = { className, style, destructive };

  return (
    <StyledDiv {...props} />
  );
};

const StyledDiv = styled.div`
  width: 72px;
  height: 3px;
  align-self: center;
  margin: 16px 0;
  background-color: ${(p) => p.destructive ? "#E5084A" : "#02B8F9"};
`;

export default HorizontalDivider;
